module.exports = __webpack_public_path__ + "img/RA.dbfe5454.png";